
import React from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import StudentBackupPanel from './backup/StudentBackupPanel';
import TeacherBackupPanel from './backup/TeacherBackupPanel';
import AdminBackupPanel from './backup/AdminBackupPanel';
import PaymentBackupPanel from './backup/PaymentBackupPanel';
import CertificateBackupPanel from './backup/CertificateBackupPanel';
import HistoryBackupPanel from './backup/HistoryBackupPanel';
import ComprehensiveBackupPanel from './backup/ComprehensiveBackupPanel';
import { Database, Info, Layers } from 'lucide-react';
import { Badge } from '../ui/badge';
import { Alert, AlertDescription } from '../ui/alert';

export const BackupManagementEnhanced = () => {
  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2 mb-4">
        <Database className="h-5 w-5 text-primary" />
        <h2 className="text-lg font-semibold">Backup & Restore System</h2>
        <Badge variant="outline" className="ml-auto">Enhanced</Badge>
      </div>
      
      <Alert>
        <Layers className="h-4 w-4" />
        <AlertDescription>
          <strong>New:</strong> Comprehensive backup includes ALL system data with automatic 
          dashboard refresh and complete data restoration. Recommended for full system backups.
        </AlertDescription>
      </Alert>
      
      <Tabs defaultValue="comprehensive" className="space-y-4">
        <TabsList className="grid grid-cols-4 sm:grid-cols-4 md:grid-cols-7 w-full">
          <TabsTrigger value="comprehensive" className="text-xs">
            <Layers className="h-3 w-3 mr-1" />
            Complete
          </TabsTrigger>
          <TabsTrigger value="student">Student</TabsTrigger>
          <TabsTrigger value="teacher">Teacher</TabsTrigger>
          <TabsTrigger value="admin">Admin</TabsTrigger>
          <TabsTrigger value="certificates">Certificates</TabsTrigger>
          <TabsTrigger value="payments">Payments</TabsTrigger>
          <TabsTrigger value="history">History</TabsTrigger>
        </TabsList>
        
        <TabsContent value="comprehensive" className="space-y-4">
          <ComprehensiveBackupPanel />
        </TabsContent>
        
        <TabsContent value="student" className="space-y-4">
          <StudentBackupPanel />
        </TabsContent>
        
        <TabsContent value="teacher" className="space-y-4">
          <TeacherBackupPanel />
        </TabsContent>
        
        <TabsContent value="admin" className="space-y-4">
          <AdminBackupPanel />
        </TabsContent>
        
        <TabsContent value="certificates" className="space-y-4">
          <CertificateBackupPanel />
        </TabsContent>
        
        <TabsContent value="payments" className="space-y-4">
          <PaymentBackupPanel />
        </TabsContent>
        
        <TabsContent value="history" className="space-y-4">
          <HistoryBackupPanel />
        </TabsContent>
      </Tabs>
      
      <div className="text-xs text-muted-foreground mt-6 flex items-center gap-2">
        <Info className="h-3 w-3" />
        <span>
          Comprehensive backups ensure complete data restoration with automatic system refresh. 
          Individual backups are available for specific data types.
        </span>
      </div>
    </div>
  );
};
